
<template>
    <div class="reveal-overlay">
        <div class="reveal">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
	export default
    {
        data()
        {
            return {};
        },
	};
</script>
